// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Selectors
import { getTransportationOption } from 'store/reducers/appointment/selectors';
import { getSelfCheckinWaitState } from 'store/reducers/selfCheckIn/selectors';

// Components
import ConfirmationPage from './ConfirmationPage';

const mapStateToProps = state => ({
  transportationOption: getTransportationOption(state),
  selfCheckinWaitState: getSelfCheckinWaitState(state)
});

const mapDispatchToProps = {};

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ConfirmationPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/ConfirmationPageContainer.js